import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { VendorTsService } from '../../../../service/vendor/vendor.ts.service';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from './../../../../service/frappe/auth.service'; // Import your authentication service

@Component({
  selector: 'app-change-request',
  templateUrl: './change-request.component.html',
  styleUrls: ['./change-request.component.scss']
})
export class ChangeRequestComponent implements OnInit {
  changeRequestForm!: FormGroup;
  data: any;
  loggedInUser: any;
  options = [
    { label: 'Individual', value: 'Individual' },
    { label: 'Partnership', value: 'Partnership' },
    { label: 'Corporation', value: 'Corporation' },
    { label: 'Limited Liability Co. (LLC)', value: 'Limited Liability Co. (LLC)' },
    { label: 'Limited', value: 'Limited' },
    { label: 'Govt.Org', value: 'Govt.Org' }
  ];
  options1 = [
    { label: 'Billing', value: 'Billing' },
    { label: 'Shipping', value: 'Shipping' },
    { label: 'Office', value: 'Office' },
    { label: 'Personal', value: 'Personal' },
    { label: 'Plant', value: 'Plant' },
    { label: 'Postal', value: 'Postal' },
    { label: 'Shop', value: 'Shop' },
    { label: 'Subsidiary', value: 'Subsidiary' },
    { label: 'Warehouse', value: 'Warehouse' },
    { label: 'Current', value: 'Current' },
    { label: 'Permanent', value: 'Permanent' },
    { label: 'Other', value: 'Other' }
  ];
  state = [
    { label: 'Andaman und Nico.In.', value: '26' },
    { label: 'Andra Pradesh', value: '1' },
    { label: 'Arunachal Pradesh', value: '2' },
    { label: 'Assam', value: '3' },
    { label: 'Bihar', value: '4' },
    { label: 'Chandigarh', value: '27' },
    { label: 'Chhaattisgarh', value: '33' },
    { label: 'Dadra und Nagar Hav.', value: '28' },
    { label: 'Daman und Diu', value: '29' },
    { label: 'Delhi', value: '30' },
    { label: 'Exports', value: '96' },
    { label: 'Goa', value: '5' },
    { label: 'Gujarat', value: '6' },
    { label: 'Haryana', value: '7' },
    { label: 'Himachal Pradesh', value: '8' },
    { label: 'Jammu and Kashmir', value: '9' },
    { label: 'Jharkhand', value: '34' },
    { label: 'Karnataka', value: '10' },
    { label: 'Kerala', value: '11' },
    { label: 'Lakshadweep', value: '31' },
    { label: 'Madhya Pradesh', value: '12' },
    { label: 'Maharashtra', value: '13' },
    { label: 'Manipur', value: '14' },
    { label: 'Megalaya', value: '15' },
    { label: 'Mizoram', value: '16' },
    { label: 'Nagaland', value: '17' },
    { label: 'Orissa', value: '18' },
    { label: 'Other - Exports', value: '0' },
    { label: 'Pondicherry', value: '32' },
    { label: 'Punjab', value: '19' },
    { label: 'Rajasthan', value: '20' },
    { label: 'Sikkim', value: '21' },
    { label: 'Tamil Nadu', value: '22' },
    { label: 'Telangana', value: '36' },
    { label: 'Tripura', value: '23' },
    { label: 'Uttar Pradesh', value: '24' },
    { label: 'Uttarakhand', value: '35' },
    { label: 'West Bengal', value: '25' }
];
  constructor(
    private formBuilder: FormBuilder,
    public messageService: MessageService,
    private vendorService: VendorTsService,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const vendor_code = params.get('id');
      if (vendor_code) {
        this.getVendorDetails(vendor_code);
      } else {
        this.getVendorDetailsFromLoggedInUser();
      }
    });
  }

  getVendorDetails(vendor_code: string): void {
    this.vendorService.getVendorByIdForCR(vendor_code).then((data: any) => {
      this.data = data.message;
      this.initializeForm(data.message);
    }).catch(error => {
      console.error('Error fetching vendor details:', error);
    });
  }

  getVendorDetailsFromLoggedInUser(): void {
    this.authService.getVendorCode(this.loggedInUser).then((loggedInUser: any) => {
      if (loggedInUser) {
        const vendor_code = loggedInUser.vendor_code;
        this.getVendorDetails(vendor_code);
      } else {
        console.error('No logged-in user found.');
      }
    }).catch(error => {
      console.error('Error fetching logged-in user:', error);
    });
  }

  initializeForm(vendorDetails: any): void {
    this.changeRequestForm = this.formBuilder.group({
      vendor_code: [vendorDetails.vendor_code, Validators.required],
      business_name: [vendorDetails.business_name, Validators.required],
      vendor_classification: [vendorDetails.vendor_classification, Validators.required],
      address_type:[vendorDetails.primary_address.address_type],
      other_address: this.formBuilder.group({
        address_title: ['', Validators.required],
        address_type: ['', Validators.required],
        address_line_1: ['', Validators.required],
        address_line_2: [''],
        city: [''],
        country: [''],
        state: [''],
        postal_code: [''],
        email_address: ['',Validators.email],
        phone_no: [''],
        fax: [''],
        contact_person: this.formBuilder.group({
          name1: ['', Validators.required],
          phone_no: [''],
          mobile_no: ['', Validators.required],
          e_mail_id: ['', [Validators.required,Validators.email]],
          website_url: ['']
        }),
        bank_detail: this.formBuilder.group({
          account_holder__registered_name: ['', Validators.required],
          account_no: ['', Validators.required],
          bank_name: [''],
          bank_address: [''],
          ifsc_code: ['', Validators.required]
        }),
        tax_details: this.formBuilder.group({
          gstn: [''],
          vat_registration_number: [''],
          service_tax_registration_number: ['']
        })
      })
    });
    this.changeRequestForm.get('other_address.country')?.valueChanges.subscribe((value) => {
      this.setGSTNValidation(value);
    });

  }

  setGSTNValidation(country: string) {
    const gstnControl = this.changeRequestForm.get('other_address.tax_details.gstn');
    if (this.isCountryIndia(country)) {
      gstnControl?.setValidators([Validators.required]);
    } else {
      gstnControl?.clearValidators();
    }
    gstnControl?.updateValueAndValidity();
  }

  isCountryIndia(country: string | null): boolean {
    if (!country) return false;
    const lowercaseCountry = country.toLowerCase();
    return ['india', 'in', 'ind'].includes(lowercaseCountry);
  }
  validateNumber(event: KeyboardEvent) {
    if (!/[0-9]/.test(event.key) && !event.ctrlKey && !['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(event.key)) {
      event.preventDefault();
    }
  }
  submitForm() {
    if (this.changeRequestForm.valid) {
      const otherAddressData = this.changeRequestForm.get('other_address')!.value;

      const businessName = this.changeRequestForm.get('business_name')!.value;

      const otherAddressArray = [{
        ...otherAddressData,
        vendor_code: otherAddressData.vendor_code || null
      }];

      const data = {
        other_address: otherAddressArray, // Use the array here
        business_name: businessName
      };
      this.vendorService.createOtherAddress(data, businessName).then(response => {
        this.changeRequestForm.get('other_address')?.reset();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Change Requested successfully' });
      }).catch(error => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create request' });

        console.error("Error updating vendor details:", error);
      });
    } else {
      console.log("Form is invalid. Please fill in all required fields.");
    }
  }


}
